import { render, staticRenderFns } from "./HorizontalList.vue?vue&type=template&id=c34820e2&scoped=true&"
import script from "./HorizontalList.vue?vue&type=script&lang=ts&"
export * from "./HorizontalList.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalList.vue?vue&type=style&index=0&id=c34820e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34820e2",
  null
  
)

export default component.exports